import React from "react";
import "../css/Security.css";

import SecurityImg from "../assets/Security.gif";

function Security() {
  const features = [
    {
      title: "No Credentials Stored",
      desc: "Your brokerage login stays private. Neither ProfiTree nor SnapTrade stores your credentials. Connections use secure, encrypted APIs and OAuth where supported.",
    },
    {
      title: "Minimal Data Collection",
      desc: "We only collect the data necessary to deliver tax optimization insights. No unnecessary personal or financial information is stored.",
    },
    {
      title: "We Don't Sell Your Data",
      desc: "Your data stays yours. We don't sell it, share it, or use it for anything beyond helping you optimize taxes.",
    },
  ];

  return (
    <section className="security-section">
      <div className="content-wrapper">
        <div className="heading-wrapper">
          <div className="left">
            <h2>
              SECURITY{" "}
              <span>
                is <u>non-negotiable!!</u>
              </span>
            </h2>
            <p>
              Powered by secure partners like SnapTrade, we ensure your data
              stays protected at every step. From encryption to access control,
              your privacy and protection are always our top priority
            </p>
          </div>
          <img src={SecurityImg} />
        </div>
        <div className="security-features-container">
          {features.map((feature, index) => (
            <div key={index} className="security-feature-item">
              <div className="security-feature-text">
                <h4>{feature.title}</h4>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Security;
